module.exports = __webpack_public_path__ + "img/SA.e9b568d8.svg";